module.exports = __webpack_public_path__ + "static/Acc-Academy-e0e74c95176f0bcfb3c115cc3c695cf7.png";